import { render, staticRenderFns } from "./data24.vue?vue&type=template&id=2ecc584f&scoped=true&"
import script from "./data24.vue?vue&type=script&lang=js&"
export * from "./data24.vue?vue&type=script&lang=js&"
import style1 from "./data24.vue?vue&type=style&index=1&id=2ecc584f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc584f",
  null
  
)

export default component.exports